import { render, staticRenderFns } from "./MainLessonFrontPage.vue?vue&type=template&id=03719e3c&scoped=true&"
import script from "./MainLessonFrontPage.vue?vue&type=script&lang=js&"
export * from "./MainLessonFrontPage.vue?vue&type=script&lang=js&"
import style0 from "./MainLessonFrontPage.vue?vue&type=style&index=0&id=03719e3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03719e3c",
  null
  
)

export default component.exports